module.exports = __webpack_public_path__ + "static/img/school-13.8097100.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/school-13.png
// module id = x3uK
// module chunks = 1